<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/BVv0i0/tc-custom/9781504072052.jpg?1737682692392" alt="This image is the cover for the book French Escape"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">French Escape
      </h1>
      <p class="bookDescription body article font2">
        <b>“With plenty of ups and downs, romance and friendship, the incomparable beauty of rural France . . . [it] is amazing in every possible way.” —<i>Books of All Kinds</i></b><br/><br/>It’s fair to say that Flick has had a terrible year. Her beloved father died, she had the wedding of her dreams and only hours after the ceremony her husband ran out on her.<br/><br/>Brenda, fed up with her daughter living like a hermit, decides to drag Flick off to France to stay in a chateau. What could be better than an idyllic escape?<br/><br/>But when they arrive Flick discovers the chateau is all but abandoned.<br/><br/>The only upside of her French escape is the handsome and mysterious neighbour, Nate.<br/><br/>Nate loves his life living in the cottage on the grounds of the abandoned chateau but that is about to be put in jeopardy . . .<br/><br/>Can Nate and Flick ever learn to come to terms with the past and find love again?<br/><br/><b>“A fabulously fun and uplifting read. Loved it.” —<i>By the Letter Book Reviews</i></b><br/><br/><b>“It has everything you could possibly need, princess castles, boy and girl romance as well as a devious mum.” —<i>The P. Turners Book Blog</i></b><br/><br/><b>“This book is a complete delight to read—the author has a brilliant writing style that I find addictive.” —<i>Donna’s Book Blog</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Suzie Tullett
      </h2>
      
      <p class="authorDescription body article">Suzie Tullett is an author of contemporary humorous fiction and romantic comedy. She has a Masters Degree in Television & Radio Scriptwriting and worked as a scriptwriter before becoming a full-time novelist. Her motto is to 'live, laugh, love' and when she's not busy creating her own literary masterpieces, she usually has her head in someone else's.  Suzie lives in a tiny hamlet in the middle of the French countryside, along with her husband and two Greek rescue dogs. You can find Suzie on Twitter: @SuzieTullett or you can visit her website: suzietullett.com</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Bombshell Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7ac36f37